(function () {
  'use strict';

  function getLocale() {
    var fromData =
      document.querySelector('[data-ted-reviews-locale]') ||
      document.querySelector('[data-ted-reviews-grid]');
    if (fromData) {
      var explicit =
        fromData.getAttribute('data-ted-reviews-locale') ||
        (fromData.closest('[data-ted-reviews-locale]') &&
          fromData.closest('[data-ted-reviews-locale]').getAttribute('data-ted-reviews-locale'));
      if (explicit) return String(explicit).slice(0, 2).toLowerCase();
    }
    var html = document.documentElement;
    return (html.lang || html.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function starChars(rating) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += i <= rating ? '★' : '☆';
    }
    return out;
  }

  function childLabel(review, locale) {
    if (locale === 'fr') {
      return 'Parent de ' + review.child + ', ' + review.age + ' ans';
    }
    return 'Parent of ' + review.child + ', ' + review.age + ' years old';
  }

  function verifiedLabel(locale) {
    return locale === 'fr' ? '✓ Achat vérifié' : '✓ Verified purchase';
  }

  function wrapQuote(text, locale) {
    var t = String(text || '').trim();
    if (!t) return '';
    if (t.charAt(0) === '«' || t.charAt(0) === '"') return t;
    return locale === 'fr' ? '« ' + t + ' »' : '"' + t + '"';
  }

  function renderShellCard(review, locale) {
    var comment = locale === 'fr' ? review.comment_fr : review.comment_en;
    var initial = String(review.parent || '?').charAt(0).toUpperCase();
    return (
      '<figure>' +
      '<div class="review-card-top">' +
      '<span class="stars" aria-label="' +
      review.rating +
      ' / 5">' +
      starChars(review.rating) +
      '</span>' +
      '<span class="verified-purchase">' +
      verifiedLabel(locale) +
      '</span>' +
      '</div>' +
      '<blockquote>' +
      escapeHtml(wrapQuote(comment, locale)) +
      '</blockquote>' +
      '<figcaption>' +
      '<span class="avatar">' +
      escapeHtml(initial) +
      '</span>' +
      '<div><b>' +
      escapeHtml(review.parent) +
      '</b><small>' +
      escapeHtml(childLabel(review, locale)) +
      '</small></div>' +
      '</figcaption>' +
      '</figure>'
    );
  }

  function starSvg(filled) {
    var opacity = filled ? '1' : '0.22';
    return (
      '<svg class="ted-review-card__star" viewBox="0 0 20 20" fill="currentColor" style="opacity:' +
      opacity +
      '" aria-hidden="true"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.77l-4.94 2.6.94-5.5-4-3.9 5.53-.8L10 1.5z"/></svg>'
    );
  }

  function renderLegacyCard(review, locale) {
    var comment = locale === 'fr' ? review.comment_fr : review.comment_en;
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += starSvg(i <= review.rating);
    }
    var child =
      locale === 'fr'
        ? review.child + ', ' + review.age + ' ans'
        : review.child + ', ' + review.age + ' years old';
    return (
      '<article class="ted-review-card">' +
      '<span class="ted-review-card__stars" aria-label="' +
      review.rating +
      '/5">' +
      stars +
      '</span>' +
      '<blockquote class="ted-review-card__quote"><p>' +
      escapeHtml(comment) +
      '</p></blockquote>' +
      '<footer class="ted-review-card__footer">' +
      '<p class="ted-review-card__parent">' +
      escapeHtml(review.parent) +
      '</p>' +
      '<p class="ted-review-card__child">' +
      escapeHtml(child) +
      '</p>' +
      '</footer>' +
      '</article>'
    );
  }

  function initPage() {
    var grid = document.querySelector('[data-ted-reviews-grid]');
    if (!grid) return;

    var dataEl =
      document.querySelector('[data-ted-reviews-data]') ||
      grid.closest('[data-ted-reviews-data]');
    if (!dataEl) return;

    var url = dataEl.getAttribute('data-ted-reviews-data');
    if (!url) return;

    var locale = getLocale();
    var shell = grid.hasAttribute('data-ted-shell-reviews');

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (!reviews.length) {
          grid.innerHTML = '';
          return;
        }
        grid.innerHTML = reviews
          .map(function (r) {
            return shell ? renderShellCard(r, locale) : renderLegacyCard(r, locale);
          })
          .join('');
      })
      .catch(function () {
        grid.innerHTML = '';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }
})();
